export default "__VITE_ASSET__dc81e60f__"